import { action, computed, observable, makeObservable } from "mobx";
import Configuracao from "../utils/Configuracao";
import FiltroImportacaoStore from "./FiltroImportacaoStore";
import ImportacaoProcessosStore from "./ImportacaoProcessosStore";

class PaginacaoImportacaoStore {
    paginaCompleta: number = 1;
    paginaFiltro: number = 1;

    constructor() {
        makeObservable(this, {
            paginaCompleta: observable,
            paginaFiltro: observable,
            primeiroIndice: computed,
            ultimoIndice: computed,
            qtdProcessos: computed,
            qtdPaginas: computed,
            pagina: computed,
            registroInicial: computed,
            registroFinal: computed,
            reiniciar: action,
            handleTrocaPagina: action
        });
    }

    get primeiroIndice() {
        return (this.pagina - 1) * Configuracao.TAMANHO_PAGINA;
    }
    get ultimoIndice() {
        return this.pagina * Configuracao.TAMANHO_PAGINA;
    }

    get qtdProcessos() {
        let processosLength = 0;
        if (FiltroImportacaoStore.filtroAplicado) {
            processosLength = ImportacaoProcessosStore.processosQuePodemSerImportadosFiltrado.length;
        } else {
            processosLength = ImportacaoProcessosStore.processosQuePodemSerImportados.length;
        }
        return processosLength;
    }

    get qtdPaginas() {
        return this.qtdProcessos <= Configuracao.TAMANHO_PAGINA ? 1 : Math.ceil(this.qtdProcessos / Configuracao.TAMANHO_PAGINA);
    }

    get pagina() {
        if (FiltroImportacaoStore.filtroAplicado) {
            return this.paginaFiltro;
        } else {
            return this.paginaCompleta;
        }
    }
    get registroInicial() {
        if (this.qtdProcessos === 0) {
            return 0;
        }
        return (this.pagina - 1) * Configuracao.TAMANHO_PAGINA + 1;
    }
    get registroFinal() {
        if (this.qtdProcessos === 0) {
            return 0;
        }
        return this.pagina === this.qtdPaginas ? this.qtdProcessos : this.pagina * Configuracao.TAMANHO_PAGINA;
    }

    reiniciar = () => {
        this.paginaCompleta = 1;
        this.paginaFiltro = 1;
    };

    handleTrocaPagina = (novaPagina) => {

        if (novaPagina <= 0) {
            novaPagina = 1;
        } else if (novaPagina > this.qtdPaginas) {
            novaPagina = this.qtdPaginas;
        }

        if (FiltroImportacaoStore.filtroAplicado) {
            this.paginaFiltro = novaPagina;
        } else {
            this.paginaCompleta = novaPagina;
        }
    };

    handlePaginaAnterior = () => {
        this.handleTrocaPagina(this.pagina - 1);
    }

    handleProximaPagina = () => {
        this.handleTrocaPagina(this.pagina + 1);
    }
}

export default new PaginacaoImportacaoStore();
